import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

import { Customer } from 'graphql/models/generated';
import { DataTableResourceType } from 'models/data.model';
import { OfferBase } from 'models/offer.model';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';
import { OfferPositionService } from 'shared/services/offer-position.service';
import { ConfirmModalService } from 'shared/services/confirm-modal.service';

@Component({
  selector: 'app-customer-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class CustomerSearchComponent implements OnInit, OnDestroy {
  @Input() resourceType: DataTableResourceType = 'Customer';

  selectedItem!: Customer;

  offer!: OfferBase;

  customerId = '';

  isDealer!: boolean;

  subs = new Subscription();

  constructor(
    private offerService: OfferService,
    private storeService: StoreService,
    private offerPositionService: OfferPositionService,
    private confirmModalService: ConfirmModalService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.storeService.resetCurrentDataItems();
    this.subs.add(combineLatest([this.storeService.getCurrentOffer(), this.storeService.isCurrentAccountDealer()]).subscribe(
      ([offer, isDealer]) => {
        this.offer = offer;
        this.customerId = offer.customerId || '';
        this.isDealer = isDealer;
      }
    ));
  }

  onSubmit(): Observable<Customer> {
    if (this.customerId && this.customerId === this.selectedItem.id) {
      return of(this.selectedItem);
    }

    if (this.offer.documentId) {
      // return selected, because Quote returns empty string
      if (this.isDealer) {
        return this.offerService.updateOfferWithCustomer(this.offer, this.selectedItem).pipe(
          map(() => this.selectedItem),
          tap((item: Customer) => this.storeService.setCurrentDataItem(item))
        );
      }

      return this.offerService.updateManufacturerOfferWithCustomer(this.offer, this.selectedItem).pipe(
        map(() => this.selectedItem),
        tap((_item: Customer) => {

          this.storeService.getCurrentOfferMeineArticleIds().pipe(
            filter(data => data.meineArticlePositionIds.length > 0),
            switchMap(data =>
              this.offerPositionService.deletePositions(
                this.offer,
                data.meineArticlePositionIds
              )
            ),
            tap(() => {
              this.confirmModalService.show('DELETED_MY_ARTICLES_INFO', {
                showCancel: false,
                confirm: 'GENERAL.OK'
              });
            })
          ).subscribe();
        }),
        tap((item: Customer) => this.storeService.setCurrentDataItem(item))
      );
    }

    return of(this.selectedItem).pipe(tap((item: Customer) => this.storeService.setCurrentDataItem(item)));
  }

  onItemSelected(item: Customer): void {
    this.selectedItem = item;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
